import { Heading } from "src/components/UI";

const ECommerceHeading = () => {
  return (
    <Heading
      fontFamily="Roboto"
      fontSize={["24px", "34px"]}
      fontWeight={["700"]}
      lineHeight={["28px", "48px"]}
      letterSpacing={["-0.24px", "-0.32px"]}
      textAlign="center"
      margin={["24px 0 16px", "46px 0 16px"]}
    >
      E-Commerce
    </Heading>
  );
};

export default ECommerceHeading;
